import React, { Suspense } from 'react';
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";

//Layout
import Admin from '../layouts/Admin';
import Auth from '../layouts/Auth';
import Empty from '../layouts/Empty';

//Context
import { useAuth } from '../context/auth';

//Components
import Loading from '../components/Loading/Loading';

export default function RoutesComponent() {
    const { session, loading } = useAuth();
    return (
        <BrowserRouter>
            {loading && <Loading />}
            <Suspense fallback={<Loading />}>
                <Routes>
                    <Route path="/" element={<Navigate to={`auth/login`} />} />
                    <Route path={`auth/*`} element={<Auth />} />
                    <Route path={`empty/*`} element={<Empty />} />
                    {
                        session != null &&
                        <Route path={`admin/*`} element={<Admin />} />
                    }
                </Routes>
            </Suspense>
        </BrowserRouter>
    );
}